import ProgressBar from '@/components/ui/ProgressBar';
import { useStepper } from '@/features/v2/lib/stepper';
import { ProgressType } from '@/features/v2/lib/wizard';

import { ECOMMERCE_STEP_NAME, ECOMMERCE_STEPS } from '../const';

// Where this part of the funnel starts on the bar — used when the active step
// cannot be resolved (no schema entry for the persisted step index).
const FIRST_BAR_STEP =
  ECOMMERCE_STEPS.findIndex(
    (item) => item.name === ECOMMERCE_STEP_NAME.DOCUMENT
  ) + 1;

export const EcommerceStepper = ({
  progressType,
  className,
}: {
  progressType: ProgressType;
  className?: string;
}) => {
  // Everything comes from the schema, as in wizard.tsx's Stepper: `progress`
  // from `progressPoints()` counted in stepper.tsx, and the bar position from
  // the active step's `name`. ECOMMERCE_STEPS is longer than the schema because
  // its first two entries happen in the pre-sale funnel, before a case exists.
  const { currentStep, progress } = useStepper();

  const isFinished = progressType !== 'default';
  const stepIndex = ECOMMERCE_STEPS.findIndex(
    (item) => item.name === currentStep?.name
  );
  const currentBarStep = stepIndex >= 0 ? stepIndex + 1 : FIRST_BAR_STEP;

  return (
    <ProgressBar
      steps={ECOMMERCE_STEPS}
      currentStep={isFinished ? ECOMMERCE_STEPS.length : currentBarStep}
      progress={isFinished ? 100 : progress}
      isFinished={isFinished}
      variant="default"
      className={className}
    />
  );
};
